import { IonButton, IonButtons, IonCol, IonGrid, IonIcon, IonLabel, IonRow, IonToolbar } from '@ionic/react'
import { addCircleOutline } from 'ionicons/icons'
import React, { BaseSyntheticEvent } from 'react'
import { useHistory } from 'react-router-dom'
import FilterComponent from '../filter/filter.component'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { useDispatch, useSelector } from 'react-redux'
import { setAddVital, setShowRepeatVitals } from '../../vitals/store/vitals.actions'
import { AppRouterConstants } from '../../../components/appRouter/AppRouter.constants'
import { getConfigurationOptionsSelector } from '../../options/selectors'
import { EKG_IMPORT_MODULE_ID } from '../../ekgImport/store/ekgImport.reducers'
import { useOfflineStatus } from '../../../utilities/isOnline.util'
import Logger from '../../../services/logger.service'
import { getEKGImportSelector } from '../../ekgImport/selectors'
import { setIsEditMode } from '../store/timeline.actions'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { useTranslation } from 'react-i18next'
import './timelineHeader.component.css'
import { StateCustomDataConstants } from '../../nemsisData/store/nemsisCustomData.constants'
import { updateCustomGroupsFromTimeLine } from '../../nemsisData/store/nemsisCustomData.actions'

const TimelineHeaderComponent: React.FC = (): JSX.Element => {
  const history = useHistory()
  const dispatch = useDispatch()
  const isOfflineStatus = useOfflineStatus()

  const { t } = useTranslation()

  const configurationOptions = useSelector(getConfigurationOptionsSelector)
  const { serviceModules } = configurationOptions
  const { monitorOptions } = useSelector(getEKGImportSelector)

  const timelineState = useSelector(getPatientTimelineSelector)
  const { isEditMode, showClearFiltersButton, items } = timelineState
  const onAddVitalsClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    dispatch(setShowRepeatVitals(true))
    dispatch(setAddVital())
    history.push(TabConstants.VITALS_TAB)
  }

  const onAddActionClick = () => {
    history.push(TabConstants.TIMELINE_ACTIONS_SEARCH)
  }

  const onEKGImportClick = () => {
    Logger.info('ECGImport: The user has started the ECG flow')
    history.push(AppRouterConstants.EKG_IMPORT_ROUTE)
  }

  const showCloudEkg =
    !isOfflineStatus &&
    serviceModules.find((i: any) => i.module_id === EKG_IMPORT_MODULE_ID) &&
    monitorOptions.length > 1

  const timelineHeaderLinksWrapperClass = showCloudEkg ? 'timeline-header-links-wrapper' : ''
  const timelineHeaderLinksClass = showCloudEkg ? 'timeline-header-links' : ''
  const timelineHeaderLinkClass = showCloudEkg ? 'timeline-header-link' : ''

  const onEditTimelineClick = () => {
    dispatch(setIsEditMode(!isEditMode))
    if (isEditMode) {
      dispatch(updateCustomGroupsFromTimeLine(StateCustomDataConstants.REORDER_TIMELINE_GROUP))
    }
  }

  return (
    <>
      <IonToolbar>
        <IonGrid className={timelineHeaderLinksWrapperClass}>
          <IonRow className={timelineHeaderLinksClass}>
            <IonCol className={timelineHeaderLinkClass}>
              <IonButtons>
                <IonButton data-testid='AddVitals' fill='clear' color='primary-alt' onClick={onAddVitalsClick}>
                  <IonIcon size='large' icon={addCircleOutline} />
                  {showCloudEkg ? t('timeline.vitals') : t('timeline.addVitals')}
                </IonButton>
              </IonButtons>
            </IonCol>
            <IonCol className={timelineHeaderLinkClass}>
              <IonButtons>
                <IonButton data-testid='AddAction' fill='clear' color='primary-alt' onClick={onAddActionClick}>
                  <IonIcon size='large' icon={addCircleOutline} />
                  {showCloudEkg ? t('timeline.action') : t('timeline.addAction')}
                </IonButton>
              </IonButtons>
            </IonCol>
            {showCloudEkg && (
              <IonCol className={timelineHeaderLinkClass}>
                <IonButtons>
                  <IonButton data-testid='AddAction' fill='clear' color='primary-alt' onClick={onEKGImportClick}>
                    <IonIcon size='large' icon={addCircleOutline} />
                    {t('timeline.ekg')}
                  </IonButton>
                </IonButtons>
              </IonCol>
            )}
          </IonRow>
        </IonGrid>
      </IonToolbar>

      {items && items.length > 0 && (
        <>
          <IonToolbar color='light'>
            <IonLabel className='events-label'>{t('timeline.Events')}</IonLabel>
            {!showClearFiltersButton && (
              <IonButtons slot='end'>
                <IonButton
                  className='events-button'
                  color={isEditMode ? 'success' : 'primary-alt'}
                  data-testid='EditTimeline'
                  fill='solid'
                  onClick={onEditTimelineClick}>
                  {isEditMode ? t('common.buttons.Done') : t('common.buttons.Edit')}
                </IonButton>
              </IonButtons>
            )}
          </IonToolbar>
          <hr className='events-divider' />

          {!isEditMode && <FilterComponent />}
        </>
      )}
      {!isEditMode && (
        <IonToolbar color='light'>
          <IonLabel className='grid-item-divider-label' color='medium'>
            {items && items.length > 0 && <>{t('timeline.tapToView')}</>}
          </IonLabel>
        </IonToolbar>
      )}
    </>
  )
}

export default TimelineHeaderComponent
